var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.2012,
    y: 0.707031,
    width: 56,
    height: 56,
    rx: 12,
    transform: "rotate(15 18.2012 0.707031)",
    fill: "#41A8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_42797_8143)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 17,
    width: 56,
    height: 56,
    rx: 12,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 17.5,
    width: 55,
    height: 55,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 42.0833H28M23.3333 46.1667H31.5M28 55.5C33.799 55.5 38.5 50.799 38.5 45C38.5 39.201 33.799 34.5 28 34.5C22.201 34.5 17.5 39.201 17.5 45C17.5 46.3967 17.7727 47.7296 18.2677 48.9486C18.3625 49.1819 18.4099 49.2985 18.431 49.3928C18.4517 49.4851 18.4592 49.5533 18.4592 49.6478C18.4593 49.7445 18.4417 49.8497 18.4066 50.0602L17.7148 54.2111C17.6424 54.6458 17.6061 54.8631 17.6736 55.0203C17.7326 55.1578 17.8422 55.2674 17.9797 55.3264C18.1369 55.3939 18.3542 55.3576 18.7889 55.2852L22.9398 54.5934C23.1503 54.5583 23.2555 54.5407 23.3522 54.5408C23.4467 54.5408 23.5149 54.5483 23.6072 54.569C23.7015 54.5901 23.8181 54.6375 24.0514 54.7323C25.2704 55.2273 26.6033 55.5 28 55.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_42797_8143",
    x: -16,
    y: 1,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_42797_8143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_42797_8143",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.e30e513da24d85b730a77a3b9fd979b2.svg";
export { ForwardRef as ReactComponent };